<script>
import ListDefault from "../Utils/Page/ListDefault";

export default {
    name: "List",
    mixins: [ListDefault],
    data() {
        return {
            lang: this.$ml.get('pages.concierge_service'),

            filter: {
                user_id: { value: null, type: 'text'},
            },
            tableHeader: [
                //{ label: '#', is_sort: false },
                { key: 'id', is_sort: true },
                { key: 'user_id', is_sort: true, classes: 'text-l' },
                { key: 'created_at', is_sort: true, classes: 'text-l' },
                { key: 'payment', is_sort: true, classes: 'text-l' },
                { key: 'status', is_sort: true, classes: 'text-l' },
                { key: 'is_concierge_bundle', is_sort: true, classes: 'text-l' },
            ],
            tableBody: {
                user_id: {type: 'function', function: this.getUser },
                payment: {type: 'function', function: this.getPayment },
                is_concierge_bundle: {type: 'function', function: this.getIsConciergeBundle },
                status: {
                    type: 'dictionary',
                    index: 'id',
                    local_index: 'status',
                    label: 'title',
                    dictionary: 'status'
                },
                created_at: {type: 'function', function: this.getDate }
            },

            apiList: this.$store.getters.getApiUrl('concierge_service'),
            pageRoute: 'concierge_service',
            pageRouteCreate: 'concierge_service.create',
            pageRouteEdit: 'concierge_service.edit',
        }
    },
    mounted() {
        this.getDictionaries().then(({data}) => {
            this.dictionaries = data.dictionaries
        })
    },
    methods:{
        getPayment(item) {
            if (!item.payment) {
                return null
            }
            let text = 'Payment ID '+item.payment.id
            let link = this.$router.resolve({ name: 'transaction.edit', params: {id: item.payment.id}})
            return `<a href="${link.href}" class="link">${text}</a>`
        },
        getUser(item) {
            let user = '@'+item.user.name
            let link = this.$router.resolve({ name: 'user.edit', params: {id: item.user_id}})
            return `<a href="${link.href}" class="link">${user}</a>`
        },
        getDate(item) {
            return this.$func.getDateTime(item.created_at)
        },
        getIsConciergeBundle(item) {
            return item.is_concierge_bundle ? 'Yes' : '-'
        }
    }
}
</script>

<style scoped>

</style>
